class FfBackTop extends HTMLElement {
  constructor(){
    super();
    if (window.innerWidth > 991) {
      this.showOnScroll();
    }
  }

  showOnScroll() {
    document.addEventListener("scroll", (event) => {
      (window.scrollY > 1250 && !this.classList.contains("ff-visible")) && 
      (this.classList.add("ff-visible"), this.addEventTop());
      (window.scrollY < 1250 && this.classList.contains("ff-visible")) && 
      this.classList.remove("ff-visible");

    });
  }

  addEventTop() {
    this.onclick = () => {
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  }
}
customElements.define('ff-back-to-top', FfBackTop);
